export default "__VITE_ASSET__D2yUQd$z__"